import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const currentPlaylistSelector = createSelector(
  [(state: RootState) => state.playlist],
  (playlistState) => playlistState.current
);
